export const defaultPublisherSlugMapping: {
  [key1: string]: { [key1: string]: string };
} = {
  endnote: {
    default: 'languageandtechnical',
    genericLangAndTech: 'languageandtechnical',
    genericLang: 'language',
  },
  refworks: {
    default: 'languageandtechnical',
    genericLangAndTech: 'languageandtechnical',
    genericLang: 'language',
  },
  'endnote-fusion': {
    default: 'languageandtechnical',
    genericLangAndTech: 'languageandtechnical',
    genericLang: 'language',
  },
};
